/** Ticket colour tags, shared by the canvas scene and the DOM tickets. */
export const TICKET_COLORS = [
  '#ff6b6b',
  '#4dabf7',
  '#51cf66',
  '#fcc419',
  '#cc5de8',
  '#ff922b',
] as const;

export function ticketColor(index: number): string {
  return (
    TICKET_COLORS[((index % TICKET_COLORS.length) + TICKET_COLORS.length) % TICKET_COLORS.length] ??
    '#ffffff'
  );
}

export const SIGN_YELLOW = '#ffd23f';
export const SIGN_EDGE = '#d9a514';
